import React from 'react';
import { Card } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Select } from '../../components/ui/Select';
import { Button } from '../../components/ui/Button';
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const years = Array.from({
  length: 20
}, (_, i) => String(2026 - i));
const stateOptions = [{
  value: 'AZ',
  label: 'Arizona'
}, {
  value: 'CA',
  label: 'California'
}, {
  value: 'NV',
  label: 'Nevada'
}, {
  value: 'TX',
  label: 'Texas'
}, {
  value: 'CO',
  label: 'Colorado'
}];
function SectionCard({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <Card className="overflow-hidden rounded-lg border-slate-300" data-id="element-2220" data-mp="3n9cwxbtmk33t">
      <div className="px-4 py-2.5" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-2221" data-mp="3ic31nfjk0x82">
        <h2 className="text-white text-sm font-semibold" data-id="element-2222" data-mp="33raiptjz17p5">{title}</h2>
      </div>
      <div className="p-4 sm:p-5 bg-white" data-id="element-2223" data-mp="37te5vfg060q9">{children}</div>
    </Card>;
}
export function ManageProfile() {
  return <div className="space-y-4 max-w-3xl" data-id="element-2224" data-mp="3cu1yg5jvqpml">
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-2225" data-mp="3cqxo0qftmxnh">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-2226" data-mp="2k4uw0vhb1fw2">
          Manage Profile
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-2227" data-mp="2p2o63zlqau1m">
          Update your personal information and account settings.
        </p>
      </div>

      <div className="rounded-xl p-4 sm:p-6 space-y-4" style={{
      backgroundColor: '#FDF6E3'
    }} data-id="element-2228" data-mp="2u17su285c9v1">
        {/* Contact Information */}
        <SectionCard title="Contact Information" data-id="element-2229" data-mp="21ctpd6yaglc3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2230" data-mp="26cya5968c284">
            <Input label="Title" defaultValue="Mr" data-id="element-2231" data-mp="26bdc39kpi15i" />
            <Input label="Company" data-id="element-2232" data-mp="1ybqljfp3hpt8" />
            <Input label="First Name" defaultValue="Dana" data-id="element-2233" data-mp="1yapahb82x3bi" />
            <Input label="Last Name" defaultValue="Kichen" data-id="element-2234" data-mp="1ub6pkfg9cs8o" />
            <Input label="Phone" defaultValue="4803910222" data-id="element-2235" data-mp="1u8ki0ftdacqg" />
            <Input label="Email" helperText="Leave blank to keep existing email (reggieborris@yahoo.com)" data-id="element-2236" data-mp="2810fl13i1ijz" />
          </div>
        </SectionCard>

        {/* Billing Address */}
        <SectionCard title="Billing Address" data-id="element-2237" data-mp="1fdwg1bn6dwfl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2238" data-mp="1bc2ihc8a18jn">
            <Input label="Address 1" defaultValue="14763 N. 90th Place" data-id="element-2239" data-mp="1bdvruza9y6vc" />
            <Input label="Address 2" data-id="element-2240" data-mp="1pcda4hheur5v" />
            <Input label="City" defaultValue="Scottsdale" data-id="element-2241" data-mp="1p97nd8w981db" />
            <Select label="State/Province *" defaultValue="AZ" options={stateOptions} data-id="element-2242" data-mp="1kbpokbbyb2j1" />
            <Input label="Zip" defaultValue="85260" data-id="element-2243" data-mp="30sk14rnkj8p5" />
          </div>
        </SectionCard>

        {/* Account & License */}
        <SectionCard title="Account & License" data-id="element-2244" data-mp="hjdceectdviz">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-2245" data-mp="hik438y7ixyq">
            <Input label="Username" helperText="Leave blank to keep existing username (student)" data-id="element-2246" data-mp="mk11guhhg2ak" />
            <Input type="password" label="Password" helperText="Leave blank to keep existing password" data-id="element-2247" data-mp="8l9stnle38tt" />
          </div>

          {/* License Expiration Date */}
          <div className="mt-4" data-id="element-2248" data-mp="159g2iox64rey">
            <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2249" data-mp="159pirksevk7g">
              License Expiration Date
            </label>
            <div className="flex items-center gap-2 flex-wrap" data-id="element-2250" data-mp="rhstrpm1hqfa">
              <select className="h-9 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-2251" data-mp="wgcke3bkvqdz">
                {months.map(m => <option key={m} selected={m === 'November'} data-id="element-2252" data-mp="1oxynsvf1zkod">
                    {m}
                  </option>)}
              </select>
              <select className="h-9 w-24 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-2253" data-mp="9j547t6acie">
                {years.map(y => <option key={y} selected={y === '2026'} data-id="element-2254" data-mp="3nglk7l9dwjoq">
                    {y}
                  </option>)}
              </select>
              <button className="text-blue-600 hover:underline text-sm" data-id="element-2255" data-mp="j2n2o49ih9ia">
                Click here to obtain your license expiration date from ADRE
              </button>
            </div>
          </div>
        </SectionCard>

        <div className="pt-1" data-id="element-2256" data-mp="a8igvz98io9m">
          <Button data-id="element-2257" data-mp="a7p6mob2hgmq">Update</Button>
        </div>
      </div>
    </div>;
}